// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"3561bac4","137":"e0d24e6c","175":"258f4e91","238":"a9e6aae9","310":"baddf9fb","377":"cd90a0ed","489":"5613e7e1","761":"3f78d96f","975":"66ee671a"}[chunkId] + ".chunk.js";
};